import { render, staticRenderFns } from "./CreateFormatDialog.vue?vue&type=template&id=4132d00c&scoped=true"
import script from "./CreateFormatDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateFormatDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CreateFormatDialog.vue?vue&type=style&index=0&id=4132d00c&prod&lang=scss"
import style1 from "./CreateFormatDialog.vue?vue&type=style&index=1&id=4132d00c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4132d00c",
  null
  
)

export default component.exports